import React from 'react';
import PropTypes from 'prop-types';

import { InfoWindow } from 'components/core/library/mapV2';
import FacilityInfoContent from './FacilityInfoContent';

export function FacilityInfoWindow({
	idleDisabled, position, facility, onClickOutside, phone, viewportWidth,
	getLocalPhoneNumberByZipCode
}) {
	return (
		<InfoWindow
			idleDisabled={idleDisabled}
			position={position}
			zIndex={3000}
			viewportWidth={viewportWidth}
		>
			<FacilityInfoContent
				facility={facility}
				onClickOutside={onClickOutside}
				getLocalPhoneNumberByZipCode={getLocalPhoneNumberByZipCode}
				phone={phone}
			/>
		</InfoWindow>
	);
}

FacilityInfoWindow.propTypes = {
	getLocalPhoneNumberByZipCode: PropTypes.func,
	idleDisabled: PropTypes.bool,
	position: PropTypes.shape({ lat: PropTypes.number, lng: PropTypes.number }),
	facility: PropTypes.object.isRequired,
	onClickOutside: PropTypes.func,
	phone: PropTypes.object,
	viewportWidth: PropTypes.number
};

export default FacilityInfoWindow;
